import * as React from 'react'
const LMDistance = () => (
  <svg
    width={30}
    height={30}
    viewBox="0 0 9.2466021 9.2127733"
    fill="currentColor"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g id="layer1" transform="translate(-54.805772,-145.64611)">
      <rect
        style={{
          display: "none",
          fill: "#280b0b",
          stroke: "#ffffff",
          strokeWidth: 0.529167,
          strokeLinejoin: "round",
        }}
        id="rect9"
        width={209.38908}
        height={297.40347}
        x={-0.35489929}
        y={-12.06649}
      />
      <g
        id="g126"
        transform="matrix(0.83177942,0,0,0.83177942,9.2194586,25.607658)"
      >
        <path
          id="path145"
          style={{
            fill: "var(--primary)",
            fillOpacity: 1,
            strokeWidth: 0.0801984,
          }}
          d="m 64.536146,144.31525 c -0.684413,4.2e-4 -1.266166,0.50011 -1.369877,1.17661 l -0.0039,5e-5 c 0,0 -0.0037,0.0729 -0.0057,0.10774 -0.0037,0.034 -0.006,0.0682 -0.0074,0.10238 3.57e-4,0.005 7.57e-4,0.0101 0.0011,0.0151 -0.01875,0.42501 0.201997,1.3789 0.335215,1.88942 0.23851,0.91401 0.745664,2.51043 1.045678,2.49969 0.328679,-0.0117 0.852916,-1.65554 1.09348,-2.55652 0.152608,-0.57156 0.313666,-1.544 0.296408,-1.91444 -6.4e-5,-0.002 -1.29e-4,-0.002 -1.98e-4,-0.003 -0.0035,-0.0773 -0.008,-0.16706 -0.008,-0.16706 l -0.01106,1e-4 c -0.11516,-0.66441 -0.691574,-1.1497 -1.365911,-1.14994 z m -0.0047,0.65269 c 0.452356,-2e-5 0.819063,0.36669 0.819056,0.81905 -2.2e-5,0.45233 -0.366722,0.81901 -0.819056,0.81901 -0.452336,0 -0.819034,-0.36668 -0.819058,-0.81901 -6e-6,-0.45236 0.366702,-0.81907 0.819058,-0.81905 z"
        />
        <g
          id="g147"
          transform="matrix(0.12128427,0,0,0.13620482,39.769519,142.32069)"
          style={{
            fill: "var(--accent)",
          }}
        >
          <path
            style={{
              color: "#000000",
              fill: "var(--accent)",
              fillOpacity: 0,
              strokeLinecap: "square",
              strokeLinejoin: "round",
            }}
            d="m 189.25986,54.182774 -21.10693,-0.193641 a 6.4924049,6.4924049 135.53134 0 0 -6.55168,6.431277 l -0.0504,5.378323 c -0.0404,4.31603 3.42469,7.694977 7.7407,7.698262 7.48504,0.0057 14.96723,0.282387 22.2804,0.262822 4.10149,-0.01097 7.36461,3.178911 7.29012,7.280668 l -0.11628,6.40316 a 6.6100591,6.6100591 135.52018 0 1 -6.60897,6.490041 h -44.90657"
            id="path146"
          />
          <path
            id="path147"
            style={{
              color: "#000000",
              fill: "var(--accent)",
              strokeLinecap: "square",
              strokeLinejoin: "round",
            }}
            d="m 168.17156,50.798145 c -4.68187,-0.04295 -8.89137,2.271655 -8.59929,9.604704 l -0.0512,5.376393 c -0.0507,5.412332 1.20205,9.650156 9.76838,9.748932 7.43563,0.08574 14.92086,0.280949 22.28891,0.261237 3.04607,-0.0081 4.38418,2.965887 4.32958,5.025586 l 0.0526,6.307088 c -0.21369,1.856578 -1.26572,3.309828 -3.78506,3.362854 C 175.771,90.605018 159.55744,89.80601 143.43132,89.91383 l -2.90278,6.048571 h 4.67285 1.52666 0.50253 44.90676 c 4.68788,0 8.55323,-2.028715 8.63835,-8.481883 l 0.11717,-6.401773 c 0.0944,-7.117472 -4.13159,-10.608556 -9.28847,-10.594759 -7.25825,0.01942 -14.81556,-0.344436 -22.34957,-0.35017 -3.25732,-0.0025 -4.61364,-1.285084 -4.58346,-4.504786 l 0.13519,-5.189959 c 0.0233,-2.488084 0.58853,-3.684853 3.3286,-4.419503 2.7195,0.159675 14.84593,0.140969 22.26895,0.20351 0.0134,0.0042 0.027,0.0075 0.0408,0.0098 l 8.42919,0.02544 c -0.48852,-1.585672 -0.77368,-2.61414 -1.66219,-5.200856 z"
          />
        </g>
        <path
          id="path2"
          style={{
            fill: "var(--primary)",
            fillOpacity: 1,
            strokeWidth: 0.0801984,
          }}
          d="m 56.192671,149.54551 c -0.684413,4.2e-4 -1.266166,0.50011 -1.369877,1.17661 l -0.0039,5e-5 c 0,0 -0.0037,0.0729 -0.0057,0.10774 -0.0037,0.034 -0.006,0.0682 -0.0074,0.10238 3.57e-4,0.005 7.57e-4,0.0101 0.0011,0.0151 -0.01875,0.42501 0.201997,1.3789 0.335215,1.88942 0.23851,0.91401 0.745664,2.51043 1.045678,2.49969 0.328679,-0.0117 0.852916,-1.65554 1.09348,-2.55652 0.152608,-0.57156 0.313666,-1.544 0.296408,-1.91444 -6.4e-5,-0.002 -1.29e-4,-0.002 -1.98e-4,-0.003 -0.0035,-0.0773 -0.008,-0.16706 -0.008,-0.16706 l -0.01106,1e-4 c -0.11516,-0.66441 -0.691574,-1.1497 -1.365911,-1.14994 z m -0.0047,0.65269 c 0.452356,-2e-5 0.819063,0.36669 0.819056,0.81905 -2.2e-5,0.45233 -0.366722,0.81901 -0.819056,0.81901 -0.452336,0 -0.819034,-0.36668 -0.819058,-0.81901 -6e-6,-0.45236 0.366702,-0.81907 0.819058,-0.81905 z"
        />
      </g>
    </g>
  </svg>
)

export default LMDistance
